<template>
  <page-wrap>
    <layout :isEmpty="false" class="layout-customer-po-follow-up-review">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
        <export-excel @onCurrent="onExportCurrent" @onAll="onExportAll" />
      </template>
      <template v-slot:tools>
        <top-panel :orderBy.sync="orderBy" />
      </template>
      <template v-slot:content>
        <editor :orderBy="orderBy" />
      </template>
    </layout>
  </page-wrap>
</template>

<script>
export default {
  name: 'RFQOpenPOReviewIndex',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'top-panel': () => import(/* webpackChunkName: 'SupportCustomerPoFollowupReview' */ './TopPanel.vue'),
    'editor': () => import(/* webpackChunkName: 'SupportCustomerPoFollowupReview' */ './Editor.vue'),
    'export-excel': () => import(/* webpackChunkName: 'ExportExcel' */ '@/components/Shared/ExportExcel')
  },
  data () {
    return {
      displayActivityLog: true,
      orderBy: 1
    }
  },
  computed: {
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    }
  },
  methods: {
    onExportCurrent () {
      this.$bus.$emit('customer-po-followup-review-on-export', { isAll: false })
    },
    onExportAll () {
      this.$bus.$emit('customer-po-followup-review-on-export', { isAll: true })
    }
  }
}
</script>
<style lang="stylus">
.layout-customer-po-follow-up-review {
  .layout__header {
    display flex
    align-items center
    justify-content space-between
    padding-bottom 1rem
  }
}
</style>
